import { EN_1 } from "./en1";
import { EN_2 } from "./en2";
import { EN_3 } from "./en3";

export const SPIRITS_EN = { ...EN_1, ...EN_2, ...EN_3 };
